import { Button } from '@heroui/react';
import { getIconsYesNoIcons, getIconsEmotionalIcons, getIconsGradeIcons } from './helpers';
import { getIsTouchDevice } from '@/utils';
import { useStoreState } from '@/hooks';
import { useMediaQuery } from '@/hooks/useMediaQuery';

interface EmojiRaitingProps {
    type: number;
    raitingValue: number;
    setRaitingValue: (value: number) => void;
}

const EmojiRaiting = ({ raitingValue, setRaitingValue, type }: EmojiRaitingProps) => {
    const { primaryColor } = useStoreState();
    const md = useMediaQuery('(min-width: 767px)');
    const sm = useMediaQuery('(min-width: 600px)');
    const isTouchDevice = getIsTouchDevice();
    const iconSize = md ? (isTouchDevice ? '120' : '80') : sm ? '70' : '60';

    const iconTypes = {
        2: getIconsYesNoIcons(iconSize, primaryColor),
        5: getIconsGradeIcons(iconSize, primaryColor),
    };

    const icons = iconTypes[type as keyof typeof iconTypes] || getIconsEmotionalIcons(iconSize, primaryColor);

    return (
        <div className={`flex w-full items-start ${!sm ? 'pt-8' : ''}`}>
            {icons.map((item, i) => (
                <div key={i} className="flex flex-1 flex-col items-center justify-center">
                    <Button
                        isIconOnly
                        variant="light"
                        className="mb-4 h-auto w-auto p-0 md:mb-2"
                        onPress={() => setRaitingValue(item.value)}
                    >
                        {raitingValue === item.value ? item.checkedIcon : item.icon}
                    </Button>
                    {sm && (
                        <span className={`text-center ${md ? 'text-base' : 'text-xs'}`}>
                            {item.label}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default EmojiRaiting;
